const dropdownFilter = [
    {
        selector: '[data-dropdown-filter]',
        path: { filename: 'dropdownFilter' },
    },
];

export { dropdownFilter };
